import type { EhrPatientSearchResultView } from './ehr-patient-search-result';

/**
 * cmdk requires unique row values; EHR patient ids could in principle collide
 * with Heidi profile UUIDs, so namespace them.
 */
export const ehrRowValue = (result: EhrPatientSearchResultView) =>
  `__ehr__:${result.patient_id}`;
